// Copyright (c) 2024 WiseTime. All rights reserved.

import { groupWith } from "ramda"
import { DateTime } from "luxon"
import { notUndefined } from "../../../lib/utils"
import { TimeRow } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

export const recordedTime = (timeRow: TimeRow.AsObject): string =>
  DateTime.fromFormat(timeRow.activityHour.toString(), "yyyyMMddHH")
    .plus({ minutes: timeRow.firstObservedInHour, hours: timeRow.timeZoneOffset })
    .setLocale(navigator.language)
    .toLocaleString(DateTime.TIME_24_SIMPLE)

export const timeRowIdsWithDivider = (timeRows: TimeRow.AsObject[]): string[] => {
  const recordedHour = (a: TimeRow.AsObject, b: TimeRow.AsObject) => {
    const hour = (timeRow: TimeRow.AsObject) => recordedTime(timeRow).substring(0, 2)
    return hour(a) === hour(b)
  }
  return groupWith(recordedHour, timeRows)
    .map((timeRowsInHour, index, arr) => {
      if (index === arr.length - 1) {
        // Skip for single or last hour
        return undefined
      }
      const [lastTimeRow] = timeRowsInHour.slice(-1)
      return lastTimeRow?.id
    })
    .filter(notUndefined)
}
